import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
//Carousel
import Carousel from "react-bootstrap/Carousel";

//photo
import pic1 from "./assete/Food/pic1.jpg";
import pic2 from "./assete/Food/pic2.png";
import pic3 from "./assete/Food/pic3.png";
import pic4 from "./assete/Food/pic4.png";
import pic5 from "./assete/Food/pic5.png";
import pic6 from "./assete/Food/pic6.png";
import pic7 from "./assete/Food/pic7.png";
import pic8 from "./assete/Food/pic8.png";
//logo
import logo1 from "./assete/Food/logo-1.png";
import logo2 from "./assete/Food/logo2.png";
import logo3 from "./assete/Food/logo3.png";
import logo4 from "./assete/Food/logo4.png";
import logo5 from "./assete/Food/logo5.png";
import logo6 from "./assete/Food/logo6.png";
import logo7 from "./assete/Food/logo7.png";
import logo8 from "./assete/Food/logo8.jpg";

const Food = () => {
  return (
    <>
      <Grid container>
        <Grid xl={12}>
          <Box
            component="div"
            className="logo"
            sx={{
              display: "flex",

              justifyContent: "space-between",
              margin: "20px 0px",
            }}
          >
            <img src={logo1} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo2} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo3} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo4} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo5} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo6} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo7} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo8} alt="Logo" style={{ width: "10%" }}></img>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={6}>
          <Box component="div" className="text" sx={{ marginTop: "20px" }}>
            <Typography variant="h5" sx={{ fontFamily: "Homa" }}>
              سیستم کنترل و مانیتورینگ
            </Typography>
            <ul
              style={{
                fontFamily: "Homa",
                marginTop: "15px",
                fontSize: "1.15rem",
              }}
            >
              <li>کارخانه خمیر مایه خوزستان</li>
              <li>کارخانه خمیر مایه برتر کرمانشاه</li>
              <li>کارخانه خمیر مایه ایران مایه تبریز</li>
              <li>CIP کامیونهای پگاه تبریز</li>
              <li>کارخانه نمک صدف دلیجان</li>
              <li>کارخانه سپید بلور خوی</li>
              <li>
                {" "}
                دستگاه اشمیدت{" "}
                <span style={{ fontFamily: "roboto", fontSize: "1rem" }}>
                  (schimidt)
                </span>{" "}
                تاتائو ارومیه
              </li>
            </ul>
            <Typography variant="h5" sx={{ fontFamily: "Homa" }}>
              سیستم مانیتورینگ ، ثبت اطلاعات و گزارش گیری
            </Typography>
            <ul
              style={{
                fontFamily: "Homa",
                marginTop: "15px",
                fontSize: "1.15rem",
              }}
            >
              <li>
                واحد های{" "}
                <span style={{ fontFamily: "roboto", fontSize: "1rem" }}>
                  UF
                </span>{" "}
                و{" "}
                <span style={{ fontFamily: "roboto", fontSize: "1rem" }}>
                  UHT
                </span>{" "}
                پگاه تبریز
              </li>
            </ul>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={6}>
          <Box component="div">
            <Carousel
              style={{
                marginTop: "20px",
                width: "100%",
                height: "50%",
                float: "left",
              }}
            >
              <Carousel.Item>
                <img src={pic4} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic2} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic3} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic1} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic5} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic6} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic7} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic8} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
            </Carousel>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
export default Food;
